import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
// Components
import Profile from 'src/Containers/Account/Profile/Profile';
import MenuWrapper from './Containers/MenuWrapper/MenuWrapper';
import SupportContainer from './Containers/Support/SupportContainer';
import AccountContainer from './Containers/Account/AccountContainer';

import Info from './Containers/Info/Info';
import GETrainersContainer from './Containers/GETrainers/GETrainersContainer';
import AddAdminContainer from './Containers/AddAdmin/AddAdminContainer';
import Customer from './Containers/Customers/Customer';
import People from './Containers/People/People';
import AddTeamMemberContainer from './Containers/AddTeamMember/AddTeamMemberContainer';
import GeAccountContainer from './Containers/GeAccount/GeAccountContainer';
import InternalServerError from './Components/InternalServerError/InternalServerError';
import PrimaryFacility from './Containers/SetupAccount/PrimaryFacility/PrimaryFacility';
import AdminAcknowledge from './Containers/SetupAccount/AdminAcknowledge/AdminAcknowledge';
import ProductUpdates from './Containers/Support/ProductUpdates/ProductUpdates'
import NativeSupport from './Containers/Support/NativeSupport';
import NativeAccount from './Containers/Account/NativeAccount';
import { GE_DOMAIN } from './Config/constants';

let loginType = localStorage.getItem('loginType');

export const Routes = (props) => {

  return (
    <MenuWrapper
      {...props.menuWrapperProps}
    >
      <Switch>
        <Redirect
          exact
          from="/"
          to={loginType === GE_DOMAIN ? '/customer' : `${props.homePath}`}
        />
        <Route exact path="/profile" component={Profile}/>
        <Route exact path="/info" component={Info} />
        <Route exact path="/customer" component={Customer} />
        <Route exact path="/customer/:id" component={GETrainersContainer} />
        <Route exact path="/people" component={People} />
        <Route exact path="/people/:id" component={GETrainersContainer} />
        <Route
          exact
          path="/authSupport"
          render={(props) => (
            <SupportContainer {...props} isAuthorized={true} />
          )}
        />
        <Route
          exact
          path="/account"
          component={
            loginType !== GE_DOMAIN ? AccountContainer : GeAccountContainer
          }
        />
        <Route
          exact
          path="/customer/:id/addAdmin"
          component={AddAdminContainer}
        />
        <Route
          exact
          path="/people/:id/addMember"
          component={AddTeamMemberContainer}
        />
        <Route
          exact
          path="/primaryFacility"
          render={() => <PrimaryFacility />}
        />
        <Route
          exact
          path="/internalServerError"
          render={() => <InternalServerError {...props} />}
        />
        <Route
          exact
          path="/productUpdate"
          render={() => <ProductUpdates {...props} isAuthorized={true} />}
        />
        <Route exact path="/setupAccount" />
        <Route
          exact
          path="/adminAcknowledge"
          render={() => <AdminAcknowledge />}
        />
        <Route
          exact
          path="/nativeSupport"
          component={NativeSupport}
        />
        <Route
          exact
          path="/nativeAccount"
          component={NativeAccount}
        />
        <Redirect from="*" to="/" />
      </Switch>
    </MenuWrapper>
  );
};
